import { render, staticRenderFns } from "./SelectToken.vue?vue&type=template&id=efc828e8&"
import script from "./SelectToken.vue?vue&type=script&lang=js&"
export * from "./SelectToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports